__turbopack_context__.v({
  "image": "tjD6Xq_image",
  "quote": "tjD6Xq_quote",
});
